export { default as plane } from './plane.png'
export { default as skiing } from './skiing.png'
export { default as fishing } from './fishing.png'
export { default as fathering } from './father.png'



// WEBPACK FOOTER //
// ./src/layouts/images/extra/index.js